module.exports = __webpack_public_path__ + "img/Icon_Lugares_de_Servicio_Hover.20133169.svg";